// extracted by mini-css-extract-plugin
export default {"kycSummary":"KycSummary_kycSummary__8Ja3S","alert":"KycSummary_alert__zsaVM","wrapper":"KycSummary_wrapper__gUZQ2","confirmCheckbox":"KycSummary_confirmCheckbox__Rp6rs"};